import { refreshGoogleAccessToken } from '@/api/gen/auth-deprecated/auth-deprecated.gen';

let isRefreshing = false;
let refreshAccessTokenPromise: Promise<string | null> | null = null;

/**
 * Ensures that only one refreshGoogleAccessToken() call
 * occurs at a time. All parallel 401 requests queue up
 * behind the same promise.
 */
export async function getRefreshedToken(): Promise<string | null> {
  console.warn('refresh token...');
  if (!isRefreshing) {
    isRefreshing = true;
    refreshAccessTokenPromise = refreshGoogleAccessToken()
      .then(res => res.data)
      .finally(() => {
        isRefreshing = false;
      });
  }

  // Wait on the ongoing (or newly started) refresh
  return refreshAccessTokenPromise ?? null;
}
